






















































































































import {Component, Vue, Inject, Emit} from "vue-property-decorator";
import Antd from "ant-design-vue";
import AbpBase from "@/lib/abpbase";
import _ from "lodash";
import {API_GetSmsCaptcha} from "@/api/login";

@Component({
    components: {}
})
export default class loginForm extends AbpBase {

    customActiveKey = '0'
    loginBtn = false
    // login type: 0 email, 1 username, 2 telephone
    loginType = 0
    isLoginError = false
    requiredTwoStepCaptcha = false
    stepCaptchaVisible = false

    state = {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false
    }

    loginModel = {
        userNameOrEmailAddress: "",
        password: "",
        loginType: '',
        rememberMe: false,
        vueInstance: this,
    };
    form: any;
    showChangeTenant: boolean = false;

    async handleSubmit(e) {
        let self = this;
        e.preventDefault();

        let validateFields = this.customActiveKey=='1'?['mobile','code']:['username','password'];

        self.form.validateFields(validateFields,async (err, values) => {
            if (err) {
                return;
            }
            this.loginModel = _.extend(this.loginModel, values);
            this.loginModel.loginType = this.customActiveKey;

            let dialog: any = self.$message.loading("正在登录", 5);
            let ret = await self.$store.dispatch({
                type: "app/login",
                data: self.loginModel
            });


            if (ret == 0) {
                dialog();
                return;
            }
            sessionStorage.setItem(
                "rememberMe",
                this.loginModel.rememberMe ? "1" : "0"
            );
            location.reload();
        });
    }

    async login() {
        (this.$refs.loginform as any).validate(async (valid: boolean) => {
            if (valid) {
                this.$Message.loading({
                    content: this.L("LoginPrompt"),
                    duration: 0
                });
                await this.$store.dispatch({
                    type: "app/login",
                    data: this.loginModel
                });
                sessionStorage.setItem(
                    "rememberMe",
                    this.loginModel.rememberMe ? "1" : "0"
                );
                location.reload();
            }
        });
    }

    handleTabClick(key) {
        this.customActiveKey = key
        // this.form.resetFields()
    }

    handleUsernameOrEmail(rule, value, callback) {
        const {state} = this
        const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
        if (regex.test(value)) {
            state.loginType = 0
        } else {
            state.loginType = 1
        }
        callback()
    }

    beforeCreate() {
        this.form = this.$form.createForm(this);
    }

    created() {
    }

    getCaptcha(e) {
        e.preventDefault()
        const {form: {validateFields}, state} = this
        validateFields(['mobile'], {force: true}, (err, values) => {
            if (!err) {
                state.smsSendBtn = true

                const interval = window.setInterval(() => {
                    if (state.time-- <= 0) {
                        state.time = 60
                        state.smsSendBtn = false
                        window.clearInterval(interval)
                    }
                }, 1000)


                API_GetSmsCaptcha(values).then(res => {

                    let {data, errno, message} = res.data;
                    if (errno != 0) {
                        this.$notification['info']({
                            message: '提示',
                            description: message,
                            duration: 8
                        })
                        return;
                    }
                    const hide: any = this.$message.loading('验证码发送中..', 0)
                    setTimeout(hide, 2500)

                    // this.$notification['success']({
                    //     message: '提示',
                    //     description: '验证码获取成功，您的验证码为：' + data,
                    //     duration: 8
                    // })
                }).catch(err => {
                    // setTimeout(hide, 1)
                    clearInterval(interval)
                    state.time = 60
                    state.smsSendBtn = false
                    this.requestFailed(err)
                })
            }
        })
    }

    requestFailed(err) {
        this.isLoginError = true
        this.$notification['error']({
            message: '错误',
            description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
            duration: 4
        })
    }

    @Emit("register")
    register() {
        return 1;
    }

    @Emit("changePass")
    changePass() {
        return 1;
    }


}
